// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__7DNbB","content":"Consent_content__39hS1","footer":"Consent_footer__3gnZf"};